// Use native IPC, never a fetch against the desktop WebView's synthetic origin.
export async function resolveDesktopSceneURL(bridge) {
  if (typeof bridge?.GetSceneWindowURL !== 'function') {
    throw new Error('Desktop 3D support is unavailable; restart the desktop app to load the updated backend');
  }
  const value = await bridge.GetSceneWindowURL();
  const url = new URL(value);
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.pathname !== '/scene-window.html') {
    throw new Error('The desktop backend returned an invalid 3D window address');
  }
  return url;
}
